module.exports = __webpack_public_path__ + "static/media/seerah1.dd718504.JPG";